import { YearTypeConst } from "constants/YearTypeConstant";
import { LabelLangString } from "component/LabelLang/label-lang";

const formatHeader = (column, index, yearType) => {
  if (column.isIndicatorName) {
    return column.headerName?.toString?.() ?? String(column.headerName);
  }

  const currentYearNoSpace = column.headerName.replaceAll(" ", "");
  if (yearType && yearType === YearTypeConst.Maly && index !== 0) {
    return `${(currentYearNoSpace - 1).toString()}/${currentYearNoSpace.toString()}`;
  }

  return column.headerName.toString();
};

const getCellValue = (column, row, currentLocale) => {
  if (column.isIndicatorName) {
    return LabelLangString({
      id: "name",
      defaultValue: row[0]?.name,
      translations: row[0]?.translations,
      currentLocale,
    });
  }

  const currentYear = column.headerName;
  const record = row.find(
    (att) =>
      `${att.month} ${att.quarter} ${att.year}` === currentYear
  );

  if (record && record.value !== null && record.value !== undefined) {
    return Math.round((record.value + Number.EPSILON) * 10) / 10;
  }

  return "N/A";
};

/**
 * Builds a 2D matrix aligned with the rendered table (headers + row values).
 */
export const buildTableMatrix = ({
  columns = [],
  rows = [],
  yearType = null,
  currentLocale = "ar",
}) => {
  if (!columns.length || !rows.length) {
    return { headers: [], rows: [] };
  }

  const headers = columns.map((col, index) =>
    formatHeader(col, index, yearType)
  );

  const dataRows = rows.map((row) =>
    columns.map((col) => getCellValue(col, row, currentLocale))
  );

  return { headers, rows: dataRows };
};

export const sanitizeExportFilename = (name) => {
  const base = (name || "export")
    .trim()
    .replace(/[<>:"/\\|?*]+/g, "-")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");

  return base || "export";
};
